import React from 'react';
import StyledSkipToContent from './SkipToContent.styles';

const SkipToContent = () => (
  <StyledSkipToContent href="#main-content" data-component="SkipToContent">
    {'Skip to Main Content'}
  </StyledSkipToContent>
);

export default SkipToContent;
